// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__3w-2P","dropdown":"Paginator_dropdown__2f82T","indicator":"Paginator_indicator__34uaP"};